import { render, staticRenderFns } from "./PxHistoricoPrecoProduto.vue?vue&type=template&id=33564126&scoped=true&"
import script from "./PxHistoricoPrecoProduto.vue?vue&type=script&lang=js&"
export * from "./PxHistoricoPrecoProduto.vue?vue&type=script&lang=js&"
import style0 from "./PxHistoricoPrecoProduto.vue?vue&type=style&index=0&id=33564126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33564126",
  null
  
)

export default component.exports